import script from "./InvestmentPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvestmentPage.vue?vue&type=script&setup=true&lang=ts"

import "./InvestmentPage.vue?vue&type=style&index=0&id=20f42f3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20f42f3a"]])

export default __exports__